function toggleDesktopMenu() {
  var menu = document.getElementById('desktop-mobile-menu');
  menu.classList.toggle('active');

  var headerWrapper = document.getElementById('header-wrapper');
  headerWrapper.classList.toggle('active'); 

  var backdrop = document.getElementById('custom-header-backdrop');
  backdrop.classList.toggle('active');

  var header = document.getElementsByClassName('section-header')[0];
  if (header) {
    header.classList.toggle('menu-open');  
    header.classList.toggle('sticky');
  }

  const form = document.querySelector("#FacetFiltersForm");
  if (form && !form.classList.contains('hidden')) {
    toggleFilters();
  }

  setDynamicColumns();
} 

function toggleMobileMenu() {
  var menu = document.getElementById('Details-menu-drawer-container');
  menu.classList.toggle('menu-opening');
  menu.toggleAttribute('open');

  var header = document.getElementsByClassName('section-header')[0];
  if (header) {
    header.classList.toggle('menu-open');  
    header.classList.toggle('sticky');
    document.body.classList.toggle('hamburger-menu-open');
  }
}

document.addEventListener('DOMContentLoaded', function() {
    document.getElementById('hamburger-icon').addEventListener('click', function() {
      if(isMobileDevice()){
        toggleMobileMenu();
      }else{
        toggleDesktopMenu();
      }
      
    });

    // Function to close the menu when clicking outside
    document.addEventListener('click', function(event) {
      if(!isMobileDevice()){
        var menu = document.getElementById('desktop-mobile-menu');
        const header =  document.getElementsByClassName('section-header')[0];
        const hamburgerIcon = document.getElementById('hamburger-icon');

        const isClickHeader = header.contains(event.target);
        const isClickInsideMenu = menu.contains(event.target);
        const isClickInsideIcon = hamburgerIcon.contains(event.target);

        if (isClickHeader && !isClickInsideMenu && !isClickInsideIcon) {
          if(menu.classList.contains('active')){
            toggleDesktopMenu();  
          }
        }
      }
    });

    // Function to close the menu when clicking outside
    const closeMenuButton = document.getElementById('close-menu');
    if(closeMenuButton){
    closeMenuButton.addEventListener('click', function() { 
      if(isMobileDevice()){
        var menu = document.getElementById('Details-menu-drawer-container');
        menu.classList.remove('menu-opening');
        menu.removeAttribute('open');

        var header = document.getElementsByClassName('section-header')[0];
        if (header) {
          header.classList.toggle('menu-open');  
          header.classList.toggle('sticky');
        }
      }
    });
    }
});




function setDynamicColumns(){
   const menuColumns = document.querySelectorAll('.menu-column');

    menuColumns.forEach(column => {
      const items = Array.from(column.querySelectorAll('ul li'));
      
      if (items.length > 5) {
        // Create a container for the sub-columns
        const subColumnsDiv = document.createElement('div');
        subColumnsDiv.classList.add('sub-columns');
        
        // Split the items into groups of 4
        while (items.length > 0) {
          const group = items.splice(0, 5); // Get up to 4 items from the array
          
          // Create a new ul for each group of up to 4 items
          const newColumn = document.createElement('ul');
          group.forEach(item => newColumn.appendChild(item));
          
          // Add the new column to the sub-columns container
          subColumnsDiv.appendChild(newColumn);
        }
        
        // Replace the original ul with the newly created sub-columns
        column.querySelector('ul').replaceWith(subColumnsDiv);
      }
    });

}
